
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4ff2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9iiIw", function(module, exports) {

$parcel$export(module.exports, "utcString2userTzDate", function () { return $99c1141bfe7f927b$export$eed8ce5347a58f09; });
$parcel$export(module.exports, "userTzDate2utcString", function () { return $99c1141bfe7f927b$export$cd22809177ba486; });
$parcel$export(module.exports, "formatDateRange", function () { return $99c1141bfe7f927b$export$2e9241a0bdf6c8b8; });

var $lAMhd = parcelRequire("lAMhd");

var $cEdoj = parcelRequire("cEdoj");

var $kAvJe = parcelRequire("kAvJe");

var $az4ls = parcelRequire("az4ls");

var $jfdA5 = parcelRequire("jfdA5");

var $8UKT5 = parcelRequire("8UKT5");
function $99c1141bfe7f927b$export$eed8ce5347a58f09(str) {
    // Always return a Date even if invalid
    if (typeof str !== "string") return new Date("invalid");
    // The date should always be in the user's TZ but the input string affects
    // how the date is constructed.
    // An input string of only year or with `-` (2020-01 | 2020-1-1) will be
    // considered to be in ISO format, meaning that the user date will be this
    // date +- the TZ offset. For example:
    // 2020-01-01
    //   Tue Dec 31 2019 19:00:00 GMT-0500 (Eastern Standard Time)
    //   Wed Jan 01 2020 01:00:00 GMT+0100 (Central European Time)
    //
    // whereas 2020/01/01
    //   Wed Jan 01 2020 00:00:00 GMT-0500 (Eastern Standard Time)
    //   Wed Jan 01 2020 00:00:00 GMT+0100 (Central European Time)
    // and if converted to ISO
    //   2020-01-01T05:00:00.000Z
    //   2020-01-01T01:00:00.000Z
    //
    // The code below ensures that all dates behave the same.
    //
    const isoYearOrMonth = str.match(/^([0-9]{4})(?:-([0-9]{1,2}))?$/);
    const isoMatch = str.match(/^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})/);
    if (isoYearOrMonth || isoMatch) {
        const date = new Date(str);
        // If the date is not valid, return it and be done.
        if (isNaN(date.getTime())) return date;
        const offset = date.getTimezoneOffset();
        date.setTime(date.getTime() + offset * 60000);
        return date;
    } else // For the full date view Date does a good job, except with the ordinal
    // numbers. Remove those from the date before parsing.
    return new Date(str.replace(/([0-9])(st|nd|rd|th)/g, "$1"));
}
function $99c1141bfe7f927b$export$cd22809177ba486(date) {
    const tz = date.getTimezoneOffset();
    const d = new Date(date.getTime() - tz * 60000);
    return d.toISOString();
}
function $99c1141bfe7f927b$export$c03bb0116ee09d4b(dateString) {
    const date = $99c1141bfe7f927b$export$eed8ce5347a58f09(dateString);
    return !isNaN(date.getTime());
}
function $99c1141bfe7f927b$export$2e9241a0bdf6c8b8(start, end, datesSeparator = " to ", useOrdinalDays = true) {
    const DATE_FORMAT_FULL = useOrdinalDays ? "MMM do, yyyy" : "MMM dd, yyyy";
    // Format the label in a pretty way as to not repeat values if the month or
    // year are the same.
    // Examples:
    // Jan 1st, 2020 to Dec 31st, 2021
    // Jan 1st — Dec 31st, 2020
    // Dec 01-31, 2020
    // Dec 31st, 2020
    const startStr = (0, $lAMhd.default)(start, DATE_FORMAT_FULL);
    const endStr = (0, $lAMhd.default)(end, DATE_FORMAT_FULL);
    if (startStr === endStr) return startStr;
    // Things get trickier when we have to compare dates. Here the range plays a
    // role.
    if ((0, $cEdoj.default)(start, end) && (0, $kAvJe.default)(start, end)) return `${(0, $lAMhd.default)(start, "MMM dd")}-${(0, $lAMhd.default)(end, "dd, yyyy")}`;
    else if ((0, $kAvJe.default)(start, end)) {
        const monthDayFormat = useOrdinalDays ? "MMM do" : "MMM dd";
        return `${(0, $lAMhd.default)(start, monthDayFormat)}${datesSeparator}${endStr}`;
    } else return `${startStr}${datesSeparator}${endStr}`;
}
function $99c1141bfe7f927b$export$16bf106cb3f52bd5(date) {
    if (!date) return undefined;
    return (0, $lAMhd.default)(date, "yyyy-MM-dd");
}
function $99c1141bfe7f927b$export$5262b014bdb225e3(inputFormat) {
    const d = (0, $az4ls.default)(inputFormat, "yyyy-MM-dd", new Date());
    return isNaN(d.getTime()) ? null : d;
}
function $99c1141bfe7f927b$export$cf36134b7b6ebabc(preset) {
    let end = new Date();
    let start = (0, $jfdA5.default)(new Date());
    if (preset === "last30Days") start = (0, $8UKT5.default)(end, {
        days: 30
    });
    else if (preset === "lastYear") start = (0, $8UKT5.default)(end, {
        years: 1
    });
    else if (preset === "last10Years") start = (0, $8UKT5.default)(end, {
        years: 10
    });
    else if (preset === "2018-2022") {
        start = new Date(2018, 0, 1);
        end = new Date(2022, 11, 31);
    }
    return {
        start: start,
        end: end
    };
}

});
parcelRegister("cEdoj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93539ba63835ecce$export$2e2bcd8739ae039; });

var $1Hzzt = parcelRequire("1Hzzt");

var $83Elt = parcelRequire("83Elt");
function $93539ba63835ecce$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $83Elt.default)(2, arguments);
    var dateLeft = (0, $1Hzzt.default)(dirtyDateLeft);
    var dateRight = (0, $1Hzzt.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("kAvJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efcfc8134e3ee539$export$2e2bcd8739ae039; });

var $1Hzzt = parcelRequire("1Hzzt");

var $83Elt = parcelRequire("83Elt");
function $efcfc8134e3ee539$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $83Elt.default)(2, arguments);
    var dateLeft = (0, $1Hzzt.default)(dirtyDateLeft);
    var dateRight = (0, $1Hzzt.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("az4ls", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b108b1d231a388e$export$2e2bcd8739ae039; });

var $cZqn8 = parcelRequire("cZqn8");

var $hAduL = parcelRequire("hAduL");

var $1Hzzt = parcelRequire("1Hzzt");

var $4zifA = parcelRequire("4zifA");

var $2OOaJ = parcelRequire("2OOaJ");

var $zuFyy = parcelRequire("zuFyy");

var $8JXF7 = parcelRequire("8JXF7");

var $dW3vb = parcelRequire("dW3vb");

var $goPVQ = parcelRequire("goPVQ");

var $83Elt = parcelRequire("83Elt");
var $7b108b1d231a388e$var$TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7b108b1d231a388e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7b108b1d231a388e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7b108b1d231a388e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7b108b1d231a388e$var$doubleQuoteRegExp = /''/g;
var $7b108b1d231a388e$var$notWhitespaceRegExp = /\S/;
var $7b108b1d231a388e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7b108b1d231a388e$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
    (0, $83Elt.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $cZqn8.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $dW3vb.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $dW3vb.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $dW3vb.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $dW3vb.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $1Hzzt.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        {
            priority: $7b108b1d231a388e$var$TIMEZONE_UNIT_PRIORITY,
            subPriority: -1,
            set: $7b108b1d231a388e$var$dateToSystemTimezone,
            index: 0
        }
    ];
    var i;
    var tokens = formatString.match($7b108b1d231a388e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $2OOaJ.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong, subFnOptions);
        }
        return substring;
    }).join("").match($7b108b1d231a388e$var$formattingTokensRegExp);
    var usedTokens = [];
    for(i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (!options.useAdditionalWeekYearTokens && (0, $8JXF7.isProtectedWeekYearToken)(token)) (0, $8JXF7.throwProtectedError)(token, formatString, dirtyDateString);
        if (!options.useAdditionalDayOfYearTokens && (0, $8JXF7.isProtectedDayOfYearToken)(token)) (0, $8JXF7.throwProtectedError)(token, formatString, dirtyDateString);
        var firstCharacter = token[0];
        var parser = (0, $goPVQ.default)[firstCharacter];
        if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;
            if (Array.isArray(incompatibleTokens)) {
                var incompatibleToken = void 0;
                for(var _i = 0; _i < usedTokens.length; _i++){
                    var usedToken = usedTokens[_i].token;
                    if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                        incompatibleToken = usedTokens[_i];
                        break;
                    }
                }
                if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
            } else if (parser.incompatibleTokens === "*" && usedTokens.length) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
            if (!parseResult) return new Date(NaN);
            setters.push({
                priority: parser.priority,
                subPriority: parser.subPriority || 0,
                set: parser.set,
                validate: parser.validate,
                value: parseResult.value,
                index: setters.length
            });
            dateString = parseResult.rest;
        } else {
            if (firstCharacter.match($7b108b1d231a388e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
             // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $7b108b1d231a388e$var$cleanEscapedString(token);
             // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
            else return new Date(NaN);
        }
    } // Check if the remaining input contains something other than whitespace
    if (dateString.length > 0 && $7b108b1d231a388e$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $1Hzzt.default)(dirtyReferenceDate);
    if (isNaN(date)) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
    var utcDate = (0, $hAduL.default)(date, (0, $zuFyy.default)(date));
    var flags = {};
    for(i = 0; i < uniquePrioritySetters.length; i++){
        var setter = uniquePrioritySetters[i];
        if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) return new Date(NaN);
        var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
        if (result[0]) {
            utcDate = result[0];
            (0, $4zifA.default)(flags, result[1]); // Result is date
        } else utcDate = result;
    }
    return utcDate;
}
function $7b108b1d231a388e$var$dateToSystemTimezone(date, flags) {
    if (flags.timestampIsSet) return date;
    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
}
function $7b108b1d231a388e$var$cleanEscapedString(input) {
    return input.match($7b108b1d231a388e$var$escapedStringRegExp)[1].replace($7b108b1d231a388e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("4zifA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $353896788bfa3b99$export$2e2bcd8739ae039; });
function $353896788bfa3b99$export$2e2bcd8739ae039(target, dirtyObject) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}

});

parcelRegister("goPVQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf072bd984fbcb74$export$2e2bcd8739ae039; });

var $8wkrN = parcelRequire("8wkrN");

var $kpmjQ = parcelRequire("kpmjQ");

var $ksxrz = parcelRequire("ksxrz");

var $8RAyE = parcelRequire("8RAyE");

var $ikCQd = parcelRequire("ikCQd");

var $7HoTC = parcelRequire("7HoTC");

var $2oKka = parcelRequire("2oKka");
var $bf072bd984fbcb74$var$MILLISECONDS_IN_HOUR = 3600000;
var $bf072bd984fbcb74$var$MILLISECONDS_IN_MINUTE = 60000;
var $bf072bd984fbcb74$var$MILLISECONDS_IN_SECOND = 1000;
var $bf072bd984fbcb74$var$numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $bf072bd984fbcb74$var$timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $bf072bd984fbcb74$var$parseNumericPattern(pattern, string, valueCallback) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
    var value = parseInt(matchResult[0], 10);
    return {
        value: valueCallback ? valueCallback(value) : value,
        rest: string.slice(matchResult[0].length)
    };
}
function $bf072bd984fbcb74$var$parseTimezonePattern(pattern, string) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: string.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $bf072bd984fbcb74$var$MILLISECONDS_IN_HOUR + minutes * $bf072bd984fbcb74$var$MILLISECONDS_IN_MINUTE + seconds * $bf072bd984fbcb74$var$MILLISECONDS_IN_SECOND),
        rest: string.slice(matchResult[0].length)
    };
}
function $bf072bd984fbcb74$var$parseAnyDigitsSigned(string, valueCallback) {
    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.anyDigitsSigned, string, valueCallback);
}
function $bf072bd984fbcb74$var$parseNDigits(n, string, valueCallback) {
    switch(n){
        case 1:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.singleDigit, string, valueCallback);
        case 2:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.twoDigits, string, valueCallback);
        case 3:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.threeDigits, string, valueCallback);
        case 4:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.fourDigits, string, valueCallback);
        default:
            return $bf072bd984fbcb74$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), string, valueCallback);
    }
}
function $bf072bd984fbcb74$var$parseNDigitsSigned(n, string, valueCallback) {
    switch(n){
        case 1:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.singleDigitSigned, string, valueCallback);
        case 2:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.twoDigitsSigned, string, valueCallback);
        case 3:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.threeDigitsSigned, string, valueCallback);
        case 4:
            return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.fourDigitsSigned, string, valueCallback);
        default:
            return $bf072bd984fbcb74$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), string, valueCallback);
    }
}
function $bf072bd984fbcb74$var$dayPeriodEnumToHours(enumValue) {
    switch(enumValue){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $bf072bd984fbcb74$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
var $bf072bd984fbcb74$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bf072bd984fbcb74$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // User for validation
function $bf072bd984fbcb74$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ var $bf072bd984fbcb74$var$parsers = {
    // Era
    G: {
        priority: 140,
        parse: function(string, token, match, _options) {
            switch(token){
                // AD, BC
                case "G":
                case "GG":
                case "GGG":
                    return match.era(string, {
                        width: "abbreviated"
                    }) || match.era(string, {
                        width: "narrow"
                    });
                // A, B
                case "GGGGG":
                    return match.era(string, {
                        width: "narrow"
                    });
                // Anno Domini, Before Christ
                case "GGGG":
                default:
                    return match.era(string, {
                        width: "wide"
                    }) || match.era(string, {
                        width: "abbreviated"
                    }) || match.era(string, {
                        width: "narrow"
                    });
            }
        },
        set: function(date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "R",
            "u",
            "t",
            "T"
        ]
    },
    // Year
    y: {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === "yy"
                };
            };
            switch(token){
                case "y":
                    return $bf072bd984fbcb74$var$parseNDigits(4, string, valueCallback);
                case "yo":
                    return match.ordinalNumber(string, {
                        unit: "year",
                        valueCallback: valueCallback
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $bf072bd984fbcb74$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Local week-numbering year
    Y: {
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === "YY"
                };
            };
            switch(token){
                case "Y":
                    return $bf072bd984fbcb74$var$parseNDigits(4, string, valueCallback);
                case "Yo":
                    return match.ordinalNumber(string, {
                        unit: "year",
                        valueCallback: valueCallback
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, options) {
            var currentYear = (0, $8wkrN.default)(date, options);
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $bf072bd984fbcb74$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $2oKka.default)(date, options);
            }
            var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return (0, $2oKka.default)(date, options);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    // ISO week-numbering year
    R: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === "R") return $bf072bd984fbcb74$var$parseNDigitsSigned(4, string);
            return $bf072bd984fbcb74$var$parseNDigitsSigned(token.length, string);
        },
        set: function(_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return (0, $7HoTC.default)(firstWeekOfYear);
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Extended year
    u: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === "u") return $bf072bd984fbcb74$var$parseNDigitsSigned(4, string);
            return $bf072bd984fbcb74$var$parseNDigitsSigned(token.length, string);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Quarter
    Q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case "Q":
                case "QQ":
                    // 01, 02, 03, 04
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case "Qo":
                    return match.ordinalNumber(string, {
                        unit: "quarter"
                    });
                // Q1, Q2, Q3, Q4
                case "QQQ":
                    return match.quarter(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case "QQQQQ":
                    return match.quarter(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // 1st quarter, 2nd quarter, ...
                case "QQQQ":
                default:
                    return match.quarter(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.quarter(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Stand-alone quarter
    q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case "q":
                case "qq":
                    // 01, 02, 03, 04
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case "qo":
                    return match.ordinalNumber(string, {
                        unit: "quarter"
                    });
                // Q1, Q2, Q3, Q4
                case "qqq":
                    return match.quarter(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case "qqqqq":
                    return match.quarter(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // 1st quarter, 2nd quarter, ...
                case "qqqq":
                default:
                    return match.quarter(string, {
                        width: "wide",
                        context: "standalone"
                    }) || match.quarter(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Month
    M: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case "M":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case "MM":
                    return $bf072bd984fbcb74$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case "Mo":
                    return match.ordinalNumber(string, {
                        unit: "month",
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case "MMM":
                    return match.month(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // J, F, ..., D
                case "MMMMM":
                    return match.month(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // January, February, ..., December
                case "MMMM":
                default:
                    return match.month(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.month(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Stand-alone month
    L: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case "L":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case "LL":
                    return $bf072bd984fbcb74$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case "Lo":
                    return match.ordinalNumber(string, {
                        unit: "month",
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case "LLL":
                    return match.month(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // J, F, ..., D
                case "LLLLL":
                    return match.month(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // January, February, ..., December
                case "LLLL":
                default:
                    return match.month(string, {
                        width: "wide",
                        context: "standalone"
                    }) || match.month(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Local week of year
    w: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case "w":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.week, string);
                case "wo":
                    return match.ordinalNumber(string, {
                        unit: "week"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $2oKka.default)((0, $ikCQd.default)(date, value, options), options);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    // ISO week of year
    I: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case "I":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.week, string);
                case "Io":
                    return match.ordinalNumber(string, {
                        unit: "week"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $7HoTC.default)((0, $8RAyE.default)(date, value, options), options);
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Day of the month
    d: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case "d":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.date, string);
                case "do":
                    return match.ordinalNumber(string, {
                        unit: "date"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $bf072bd984fbcb74$var$isLeapYearIndex(year);
            var month = date.getUTCMonth();
            if (isLeapYear) return value >= 1 && value <= $bf072bd984fbcb74$var$DAYS_IN_MONTH_LEAP_YEAR[month];
            else return value >= 1 && value <= $bf072bd984fbcb74$var$DAYS_IN_MONTH[month];
        },
        set: function(date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Day of year
    D: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case "D":
                case "DD":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.dayOfYear, string);
                case "Do":
                    return match.ordinalNumber(string, {
                        unit: "date"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $bf072bd984fbcb74$var$isLeapYearIndex(year);
            if (isLeapYear) return value >= 1 && value <= 366;
            else return value >= 1 && value <= 365;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Day of week
    E: {
        priority: 90,
        parse: function(string, token, match, _options) {
            switch(token){
                // Tue
                case "E":
                case "EE":
                case "EEE":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // T
                case "EEEEE":
                    return match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tu
                case "EEEEEE":
                    return match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tuesday
                case "EEEE":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $kpmjQ.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Local day of week
    e: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case "e":
                case "ee":
                    // 03
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case "eo":
                    return match.ordinalNumber(string, {
                        unit: "day",
                        valueCallback: valueCallback
                    });
                // Tue
                case "eee":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // T
                case "eeeee":
                    return match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tu
                case "eeeeee":
                    return match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tuesday
                case "eeee":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $kpmjQ.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]
    },
    // Stand-alone local day of week
    c: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case "c":
                case "cc":
                    // 03
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case "co":
                    return match.ordinalNumber(string, {
                        unit: "day",
                        valueCallback: valueCallback
                    });
                // Tue
                case "ccc":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "short",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // T
                case "ccccc":
                    return match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // Tu
                case "cccccc":
                    return match.day(string, {
                        width: "short",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // Tuesday
                case "cccc":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "short",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $kpmjQ.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]
    },
    // ISO day of week
    i: {
        priority: 90,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                if (value === 0) return 7;
                return value;
            };
            switch(token){
                // 2
                case "i":
                case "ii":
                    // 02
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
                // 2nd
                case "io":
                    return match.ordinalNumber(string, {
                        unit: "day"
                    });
                // Tue
                case "iii":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
                // T
                case "iiiii":
                    return match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
                // Tu
                case "iiiiii":
                    return match.day(string, {
                        width: "short",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
                // Tuesday
                case "iiii":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 7;
        },
        set: function(date, _flags, value, options) {
            date = (0, $ksxrz.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // AM or PM
    a: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case "a":
                case "aa":
                case "aaa":
                    return match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaaa":
                    return match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaa":
                default:
                    return match.dayPeriod(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($bf072bd984fbcb74$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]
    },
    // AM, PM, midnight
    b: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case "b":
                case "bb":
                case "bbb":
                    return match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbbb":
                    return match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbb":
                default:
                    return match.dayPeriod(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($bf072bd984fbcb74$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]
    },
    // in the morning, in the afternoon, in the evening, at night
    B: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case "B":
                case "BB":
                case "BBB":
                    return match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBBB":
                    return match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBB":
                default:
                    return match.dayPeriod(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($bf072bd984fbcb74$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "b",
            "t",
            "T"
        ]
    },
    // Hour [1-12]
    h: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "h":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.hour12h, string);
                case "ho":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 12;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    // Hour [0-23]
    H: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "H":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.hour23h, string);
                case "Ho":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 23;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    // Hour [0-11]
    K: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "K":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.hour11h, string);
                case "Ko":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]
    },
    // Hour [1-24]
    k: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "k":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.hour24h, string);
                case "ko":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 24;
        },
        set: function(date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]
    },
    // Minute
    m: {
        priority: 60,
        parse: function(string, token, match, _options) {
            switch(token){
                case "m":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.minute, string);
                case "mo":
                    return match.ordinalNumber(string, {
                        unit: "minute"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    // Second
    s: {
        priority: 50,
        parse: function(string, token, match, _options) {
            switch(token){
                case "s":
                    return $bf072bd984fbcb74$var$parseNumericPattern($bf072bd984fbcb74$var$numericPatterns.second, string);
                case "so":
                    return match.ordinalNumber(string, {
                        unit: "second"
                    });
                default:
                    return $bf072bd984fbcb74$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    // Fraction of second
    S: {
        priority: 30,
        parse: function(string, token, _match, _options) {
            var valueCallback = function(value) {
                return Math.floor(value * Math.pow(10, -token.length + 3));
            };
            return $bf072bd984fbcb74$var$parseNDigits(token.length, string, valueCallback);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    // Timezone (ISO-8601. +00:00 is `'Z'`)
    X: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case "X":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.basicOptionalMinutes, string);
                case "XX":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.basic, string);
                case "XXXX":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.basicOptionalSeconds, string);
                case "XXXXX":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.extendedOptionalSeconds, string);
                case "XXX":
                default:
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            "t",
            "T",
            "x"
        ]
    },
    // Timezone (ISO-8601)
    x: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case "x":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.basicOptionalMinutes, string);
                case "xx":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.basic, string);
                case "xxxx":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.basicOptionalSeconds, string);
                case "xxxxx":
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.extendedOptionalSeconds, string);
                case "xxx":
                default:
                    return $bf072bd984fbcb74$var$parseTimezonePattern($bf072bd984fbcb74$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            "t",
            "T",
            "X"
        ]
    },
    // Seconds timestamp
    t: {
        priority: 40,
        parse: function(string, _token, _match, _options) {
            return $bf072bd984fbcb74$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value * 1000),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: "*"
    },
    // Milliseconds timestamp
    T: {
        priority: 20,
        parse: function(string, _token, _match, _options) {
            return $bf072bd984fbcb74$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: "*"
    }
};
var $bf072bd984fbcb74$export$2e2bcd8739ae039 = $bf072bd984fbcb74$var$parsers;

});
parcelRegister("kpmjQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edb7748ff0976460$export$2e2bcd8739ae039; });

var $1Hzzt = parcelRequire("1Hzzt");

var $83Elt = parcelRequire("83Elt");

var $dW3vb = parcelRequire("dW3vb");
function $edb7748ff0976460$export$2e2bcd8739ae039(dirtyDate, dirtyDay, dirtyOptions) {
    (0, $83Elt.default)(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $dW3vb.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $dW3vb.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $1Hzzt.default)(dirtyDate);
    var day = (0, $dW3vb.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("ksxrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee505d5e77411715$export$2e2bcd8739ae039; });

var $1Hzzt = parcelRequire("1Hzzt");

var $83Elt = parcelRequire("83Elt");

var $dW3vb = parcelRequire("dW3vb");
function $ee505d5e77411715$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $83Elt.default)(2, arguments);
    var day = (0, $dW3vb.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $1Hzzt.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("8RAyE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673fa19cba133c78$export$2e2bcd8739ae039; });

var $dW3vb = parcelRequire("dW3vb");

var $1Hzzt = parcelRequire("1Hzzt");

var $aRovP = parcelRequire("aRovP");

var $83Elt = parcelRequire("83Elt");
function $673fa19cba133c78$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $83Elt.default)(2, arguments);
    var date = (0, $1Hzzt.default)(dirtyDate);
    var isoWeek = (0, $dW3vb.default)(dirtyISOWeek);
    var diff = (0, $aRovP.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("ikCQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5883953759e3199$export$2e2bcd8739ae039; });

var $dW3vb = parcelRequire("dW3vb");

var $1Hzzt = parcelRequire("1Hzzt");

var $95H71 = parcelRequire("95H71");

var $83Elt = parcelRequire("83Elt");
function $d5883953759e3199$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $83Elt.default)(2, arguments);
    var date = (0, $1Hzzt.default)(dirtyDate);
    var week = (0, $dW3vb.default)(dirtyWeek);
    var diff = (0, $95H71.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});



parcelRegister("jfdA5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $039d947362db55b8$export$2e2bcd8739ae039; });

var $1Hzzt = parcelRequire("1Hzzt");

var $83Elt = parcelRequire("83Elt");
function $039d947362db55b8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $83Elt.default)(1, arguments);
    var cleanDate = (0, $1Hzzt.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("8UKT5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67d7ec93e61c13ce$export$2e2bcd8739ae039; });

var $2PNb1 = parcelRequire("2PNb1");

var $brmUB = parcelRequire("brmUB");

var $83Elt = parcelRequire("83Elt");

var $dW3vb = parcelRequire("dW3vb");
function $67d7ec93e61c13ce$export$2e2bcd8739ae039(date, duration) {
    (0, $83Elt.default)(2, arguments);
    if (!duration || typeof duration !== "object") return new Date(NaN);
    var years = duration.years ? (0, $dW3vb.default)(duration.years) : 0;
    var months = duration.months ? (0, $dW3vb.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $dW3vb.default)(duration.weeks) : 0;
    var days = duration.days ? (0, $dW3vb.default)(duration.days) : 0;
    var hours = duration.hours ? (0, $dW3vb.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $dW3vb.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $dW3vb.default)(duration.seconds) : 0; // Subtract years and months
    var dateWithoutMonths = (0, $brmUB.default)(date, months + years * 12); // Subtract weeks and days
    var dateWithoutDays = (0, $2PNb1.default)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});
parcelRegister("2PNb1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21067daf214871f9$export$2e2bcd8739ae039; });

var $dW3vb = parcelRequire("dW3vb");

var $dYihI = parcelRequire("dYihI");

var $83Elt = parcelRequire("83Elt");
function $21067daf214871f9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $83Elt.default)(2, arguments);
    var amount = (0, $dW3vb.default)(dirtyAmount);
    return (0, $dYihI.default)(dirtyDate, -amount);
}

});
parcelRegister("dYihI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2bf0ff2611c2ee6$export$2e2bcd8739ae039; });

var $dW3vb = parcelRequire("dW3vb");

var $1Hzzt = parcelRequire("1Hzzt");

var $83Elt = parcelRequire("83Elt");
function $a2bf0ff2611c2ee6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $83Elt.default)(2, arguments);
    var date = (0, $1Hzzt.default)(dirtyDate);
    var amount = (0, $dW3vb.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});


parcelRegister("brmUB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8543fd2914f2000b$export$2e2bcd8739ae039; });

var $dW3vb = parcelRequire("dW3vb");

var $jQwFK = parcelRequire("jQwFK");

var $83Elt = parcelRequire("83Elt");
function $8543fd2914f2000b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $83Elt.default)(2, arguments);
    var amount = (0, $dW3vb.default)(dirtyAmount);
    return (0, $jQwFK.default)(dirtyDate, -amount);
}

});
parcelRegister("jQwFK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e72c37b1cfe02b2d$export$2e2bcd8739ae039; });

var $dW3vb = parcelRequire("dW3vb");

var $1Hzzt = parcelRequire("1Hzzt");

var $83Elt = parcelRequire("83Elt");
function $e72c37b1cfe02b2d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $83Elt.default)(2, arguments);
    var date = (0, $1Hzzt.default)(dirtyDate);
    var amount = (0, $dW3vb.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});





//# sourceMappingURL=mdx-content.00df3ab6.js.map
